/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IPublicMyHomeV1GetGeocodeRequest,
  TPublicMyHomeV1GetGeocodeModel,
  IMappers,
  TPublicMyHomeV1GetGeocodeResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetGeocodeResponse } from '../../../entities/newbuilding/GetGeocodeResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicMyHomeV1GetGeocodeModel(
  parameters: IPublicMyHomeV1GetGeocodeRequest,
): TPublicMyHomeV1GetGeocodeModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'newbuilding-estimate',
    pathApi: '/my-home/v1/get-geocode/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IPublicMyHomeV1GetGeocodeOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicMyHomeV1GetGeocodeRequest;
}

export async function fetchPublicMyHomeV1GetGeocode<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicMyHomeV1GetGeocodeOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicMyHomeV1GetGeocodeResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicMyHomeV1GetGeocodeModel(parameters),
    config,
  )) as FetchResponse<TPublicMyHomeV1GetGeocodeResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetGeocodeResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicMyHomeV1GetGeocodeResponse>;
}
